<template>
  <div
    :class="[
      'form-input-length-counter',
      {
        'form-input-length-counter--exceeded': isExceeded
      }
    ]"
  >
    <div class="form-input-length-counter__counter">{{ counterText }}</div>
    <div
      v-if="label"
      class="form-input-length-counter__label"
      :style="labelStyles"
    >
      <span v-html="currentLabel"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormInputLengthCounter',
  props: {
    label: String,
    exceededLabel: String,
    exceededLabelColor: String,
    min: [Number, String],
    max: [Number, String],
    text: String,
    stripHtml: Boolean
  },
  computed: {
    labelStyles() {
      return this.isExceeded && this.exceededLabelColor
        ? { color: this.exceededLabelColor }
        : undefined
    },
    isExceeded() {
      return this.max && this.max < this.currentLength
    },
    currentLabel() {
      return this.isExceeded && this.exceededLabel
        ? this.exceededLabel
        : this.label
    },
    currentLength() {
      let text = this.text || ''

      if (this.stripHtml) {
        text = text
          .replace(/^<p><br\/?><\/p>$/g, '')
          .replace(/<\/p><p>/g, '\n')
          .replace(/<p><br\/?><\/p>/g, '\n')
          .replace(/<([^>]+)>/g, '')
      }

      return text.length
    },
    counterText() {
      return this.max
        ? `${this.currentLength} / ${this.max}`
        : this.currentLength()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-input-length-counter {
  overflow: hidden;
  $root: &;

  &__label {
    color: $gray-500;
  }

  &__counter {
    float: right;
  }

  &--exceeded {
    #{$root}__counter {
      color: $red;
    }
  }
}
</style>
